import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon, Spinner, Modal, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, View, Dimensions, TouchableOpacity, Linking } from 'react-native';
import { useDispatch, useSelector} from 'react-redux';
import {loginNextStep, setPhoneNumber} from '../../../store/actions/login'
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../root.navigation.js';
import Constants from "expo-constants"
import * as Application from 'expo-application';

const version = Application.nativeBuildVersion
// const version = Constants.manifest.version
const width = Dimensions.get('window').width-40
const AgentIcon = (props) => (
  <Icon {...props} name='smartphone-outline'/>
);
const LinkIcon = (props) => (
  <Icon {...props}  name='external-link-outline'/>
);
const CloudIcon = (props) => (
  <Icon {...props} name='cloud-download' style={{width:48, height:48, marginHorizontal: 10}} fill='#134A93'/>
);

const AlertIcon = (props) => (
  <Icon {...props} name='alert-triangle' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);
const SuccessIcon = (props) => (
  <Icon {...props} name='checkmark-circle-2' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);


export const LoginForm = ({ navigation }) => {
  const navigateRegister = () => {
    RootNavigation.navigate('Register');
  };
  const phone = useSelector( state => state.login.phoneNumber);
  const [disableBtn, setDisableBtn] = useState(false)
  const [visible, setVisible] = useState(false)
  const [status, setStatus] = useState('primary')
  const [downloadURL, setDownloadURL] = useState('')
  const dispatch = useDispatch();

  const getLatestVersion = async()=>{
    const response = await trackerApi.post('/getLatestVersion', {});
    console.log(response.data.result.version);
    if(response.data.status && version!== response.data.result.version){
      setVisible(true)
      setDownloadURL(response.data.result.url)
    }
  }
  React.useEffect(()=>{
    getLatestVersion()
  },[])

  const loginBtn = async ()=>{

    if(phone.length == 11 && Number(phone)){
      setStatus('primary')
      setDisableBtn(true);
      const response = await trackerApi.post('/login', {phone});
      if(response.data.login){
        showMessage({
          message: response.data.message,
          type: "success",
          icon: SuccessIcon
        });
        dispatch(loginNextStep(true))
      }
      else{
        showMessage({
          message: response.data.error,
          type: "danger",
          icon: AlertIcon
        });
        setDisableBtn(false)
      }
    }
    else{
      setStatus('danger')
    }


  }

  const renderCaption = () => {
    if(status=='danger')
    { return (
        <Text status='danger' category='c2'>
        شماره خود را به صورت درست و با اعداد انگلیسی وارد نمایید.
        </Text>
      )
    }
    else return null;
  }
  const a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣۴۵۶٧٨٩'.indexOf(d));

  return (
      <ScrollView>
      <Layout level='2' style={styles.container}>
      <Input
        style={{marginVertical:5, borderRadius:10, width:Dimensions.get('window').width-40}}
        label={evaProps => <Text {...evaProps}>شماره همراه</Text>}
        textStyle={{letterSpacing:5, textAlign:'center'}}
        value={phone}
        caption = {renderCaption}
        placeholder ='شماره خود را وارد نمایید'
        status={status}
        accessoryLeft={AgentIcon}
        onChangeText = {newValue =>{ console.log(Number(newValue));dispatch(setPhoneNumber(newValue))}}
        keyboardType = 'numeric'
          maxLength={11}

        />
      <Layout level='2' style={{alignItems:'center'}}>
        <Button style={{marginTop:5,  borderRadius:10, width: Dimensions.get('window').width-40}}
          onPress={loginBtn}
          disabled = {disableBtn}
          > ارسال کد تایید</Button>
          <TouchableOpacity onPress={()=>{Linking.openURL(`tel:09126384420`)}} >
          <Text category='c2' appearance='hint' style={{marginVertical:5}}>برای ورود مشکل دارید؟</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={navigateRegister}>
          <Text category='c2' status='primary' style={{marginVertical:5}}>درخواست عضویت</Text>
          </TouchableOpacity>
        </Layout>
      </Layout>

      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    marginTop:25,
    justifyContent:'flex-start',
    alignItems:'flex-start'
  },
  indicator: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  backdrop: {
    backgroundColor: 'rgba(4, 7, 32, 0.8)',
  },
});
